import React from 'react';
import { FormattedMessage } from 'react-intl';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { history } from '../../configuration/store';
import PayrollsList from './payrollsList';
import { getPayrolls } from '../../reducers/payrolls';

class PayrollsPage extends React.Component {
    componentDidMount() {
        const { role, getPayrolls } = this.props;
        getPayrolls(role);
    }

    render() {
        const { role, payrolls } = this.props;

        return (
            <div className="page">
                <div className="row">
                    <div className="col-xs-12">
                        <h4>{PayrollsPage.meta.label}</h4>
                    </div>
                    <div className="col-xs-12">
                        <PayrollsList payrolls={payrolls} role={role} />
                    </div>
                </div>
            </div>
        );
    }
}

PayrollsPage.meta = {
    label: <FormattedMessage id={'payrolls'} defaultMessage={'Payrolls'} />,
    icon: 'local_atm',
    action: () => history.push('/payrolls'),
    locations: ['/payrolls']
};

const mapStateToProps = state => ({
    role: state.identity.role,
    payrolls: state.payrolls.list
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getPayrolls
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(PayrollsPage);



// WEBPACK FOOTER //
// ./src/pages/payrolls/index.jsx